import React from "react";
import "./CabServicesData.css";

const CabServicesData = () => {
  const YouTubePreview = ({ videoId }) => {
    const [play, setPlay] = React.useState(false);

    return (
      <div className="yt-container">
        {!play ? (
          <div className="yt-thumbnail" onClick={() => setPlay(true)}>
            <img
              src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt="video thumbnail"
            />
            <div className="play-button"></div>
          </div>
        ) : (
          <iframe
            width="100%"
            height="350"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        )}
      </div>
    );
  };
  return (
    <div className="guidance-container">
      <h1 className="main-title">BOOK TRUSTED CABS INSTANTLY</h1>

      <div className="timeline">
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>1. Introduction</h3>

            <p>Safe, Affordable & Hassle-Free Travel with ZikRme</p>

            <p>
              Looking for a reliable cab for your next ride? ZikRme makes cab
              booking simple, fast, and affordable.
            </p>

            <p>
              Whether you need a ride within the city, an airport transfer, or
              an outstation journey, our platform connects you with verified
              drivers and well-maintained vehicles to ensure a safe and
              comfortable travel experience.
            </p>

            <p>
              With ZikRme, you can book your ride in just a few clicks and enjoy
              a smooth journey without worrying about hidden charges or
              last-minute issues.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>2. About ZikRme Cab Service</h3>

            <p>
              ZikRme offers a smart and convenient cab booking service designed
              for modern travelers.
            </p>

            <p>
              Our goal is to provide reliable transportation with transparent
              pricing and professional drivers.
            </p>

            <p>
              Whether you're planning a short city ride, a long outstation trip,
              or an airport transfer, ZikRme ensures you travel comfortably and
              safely.
            </p>

            <p>
              Our wide range of vehicles and flexible travel options make it
              easy for individuals, families, tourists, and business travelers
              to find the perfect ride.
            </p>

            <p>
              ZikRme is more than just a cab booking service — it is a complete
              travel platform where you can also explore hotels, restaurants,
              and travel destinations.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>3. Features of ZikRme Cab Service</h3>

            <ul>
              <li>Local city rides for daily travel</li>
              <li>Outstation trips (One-way & Round Trip)</li>
              <li>Airport pickup and drop services</li>
              <li>24×7 cab availability</li>
              <li>Transparent pricing with no hidden charges</li>
              <li>Multiple vehicle options for different travel needs</li>
              <li>Verified and trained drivers</li>
              <li>Clean, comfortable, and well-maintained vehicles</li>
              <li>Flexible routes and customized travel plans</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>4. Cab Booking Options</h3>

            <ul>
              <li>
                <b>One-Way Trip</b> – Perfect for intercity travel when you only
                need a single drop.
              </li>
              <li>
                <b>Round Trip</b> – Ideal for business trips, family travel, and
                return journeys.
              </li>
              <li>
                <b>Local Hourly Packages</b> – Book a cab for a few hours and
                visit multiple places in the city.
              </li>
              <li>
                <b>Airport Pickup & Drop</b> – Reliable and on-time airport
                transfers.
              </li>
              <li>
                <b>Corporate Travel</b> – Professional cab services for business
                travel.
              </li>
              <li>
                <b>Tourist & Family Trips</b> – Comfortable travel options for
                sightseeing and vacations.
              </li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>5. Vehicle Options Available</h3>
            <p>Choose the vehicle that best suits your travel requirements.</p>
            <ul>
              <li>Hatchback – Budget friendly option for city rides</li>
              <li>Sedan – Comfortable and spacious travel</li>
              <li>SUV – Perfect for family trips and group travel</li>
              <li>Tempo Traveller – Ideal for large groups and tours</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>6. Why Choose ZikRme Cab Service?</h3>

            <ul>
              <li>Easy online booking</li>
              <li>Instant customer support</li>
              <li>Transparent pricing with no hidden charges</li>
              <li>Professional and verified drivers</li>
              <li>Clean and comfortable vehicles</li>
              <li>Flexible travel routes</li>
              <li>
                Affordable packages for tourists, families, and businesses
              </li>
              <li>
                Service available across multiple cities and tourist
                destinations
              </li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>7. Your Safety Is Our Priority</h3>
            <p>ZikRme ensures every ride is safe and reliable.</p>
            <ul>
              <li>Verified driver background checks</li>
              <li>Clean and sanitized cars</li>
              <li>24×7 customer support</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>8. Popular Travel Routes</h3>
            <p>Some commonly booked routes on ZikRme include:</p>
            <ul>
              <li>Delhi → Agra</li>
              <li>Delhi → Jaipur</li>
              <li>Delhi → Haridwar</li>
              <li>Indore → Ujjain</li>
              <li>Delhi → Rishikesh</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>9. How to Book Your Ride</h3>
            <p>Booking a cab with ZikRme is quick and simple.</p>
            <ul>
              <li>Visit the ZikRme booking page</li>
              <li>Select your pickup and drop location</li>
              <li>Choose your vehicle type</li>
              <li>Confirm your ride and enjoy your journey</li>
            </ul>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>10.Book Your Ride Now</h3>
            <p>👉 Click to Book on ZikRme</p>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>11. How to Book a Cab on ZikRme</h3>
            <p>
              New to ZikRme? Watch our quick tutorial to learn how to book a cab
              easily using our platform or WhatsApp.
            </p>
            <YouTubePreview videoId="dQw4w9WgXcQ" />
            <p>In this video you will learn:</p>
            <ul>
              <li>How to book a cab on ZikRme</li>
              <li>How to choose ride type (Local / Outstation / Airport)</li>
              <li>How to confirm booking through Platform</li>
              <li>How pricing and ride confirmation works</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CabServicesData;
